export const flipCoin = <T>(option1: T, option2: T, option1Probability: number = 0.5): T => {
    if (option1Probability < 0 || option1Probability > 1) {
        throw new Error('Please use number in range 0 to 1')
    }
    return Math.random() < option1Probability ? option1 : option2;
};